import * as actionTypes from './actionTypes';
import axios from 'axios';

const setBlog = ( entries ) => {
    return {
        type: actionTypes.INIT_BLOG,
        entries: entries
    }
}

export const initBlog = () => {
    return dispatch => {
        axios( {
            method: 'get', url: 'https://dtgreviews.com/wp-json/wp/v2/posts?_embed', config: {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                }
            }
        } )
            .then( resp => {
                dispatch( setBlog( resp.data ) );
            } )
    }
}

const blogGot = ( entry ) => {
    return {
        type: actionTypes.GET_BLOG,
        entry: entry
    }
}

export const getBlog = ( id ) => {
    return dispatch => {
        axios( {
            method: 'get', url: 'https://dtgreviews.com/wp-json/wp/v2/posts/' + id, config: {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                }
            }
        } )
            .then( resp => {
                dispatch( blogGot( resp.data ) );
            } )
    }
}